/**
 * 对路由进行排序
 */

const order = [
  '首页',
  '天津消防',
  '人防监测',
  '122首页',
  'RT-EAO监测',
  '多设备监控',
  '海关',
  '无人机',
  '任务监控',
  '走航监控',
  '设备监控',
  '实时监控',
  '综合查询',
  '棉包综合查询',
  '统计报表',
  '棉包统计报表',
  '远程控制',
  '数据分析',
  '拉曼数据管理'
];

function getOrder(route) {
  return order.findIndex(e => route.meta.title === e) || 0;
}

export function sortRouter(routes) {
  return routes.sort((a, b) => {
    return getOrder(a) - getOrder(b);
  }); // 排序
}
